import {useMutation} from "react-query";
import axios from 'axios'

const addTenant = async (config) => {
    const {data: response} = await axios.post(`${process.env.REACT_APP_API_URL}/admin/tenants`, config)
    return response.data;
}
export default function useAddTenant(){
    return useMutation(
        'ADD_TENANT',
        (tenantConfig) => addTenant(tenantConfig)
    )
}
